import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const EmissionsBypassPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/emissions/overview')
  }, [])
  return (
    <>
    </>
  )
}